import { render } from "./ExpenseDetails.vue?vue&type=template&id=78f48227&ts=true"
import script from "./ExpenseDetails.vue?vue&type=script&lang=ts"
export * from "./ExpenseDetails.vue?vue&type=script&lang=ts"

import "./ExpenseDetails.vue?vue&type=style&index=0&id=78f48227&lang=scss"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__